import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function t(field, lang = 'en') {
  if (!field) return '';
  return field[lang] || field.en || '';
}

export default function TermsOfService() {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('ets_lang');
    if (savedLang) setLang(savedLang);
  }, []);

  const content = {
    back: { en: '← Back to Home', zh: '← 返回首頁' },
    title: { en: 'Terms of Service', zh: '服務條款' },
    lastUpdated: { en: 'Last updated: ', zh: '最後更新：' },
    
    sec1Title: { en: '1. Agreement to Terms', zh: '1. 同意條款' },
    sec1P1: { en: 'By accessing and using Every Talent Shines Academy (ETS) services, mobile application, and website, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.', zh: '透過存取及使用 Every Talent Shines Academy (ETS) 的服務、行動應用程式及網站，即表示您同意受這些服務條款的約束。如果您不同意條款的任何部分，則不得存取該服務。' },
    
    sec2Title: { en: '2. Registration and Enrolment', zh: '2. 註冊與報名' },
    sec2P1: { en: 'Students and guardians must provide accurate, complete, and current information during the registration process. Providing false information may result in termination of services.', zh: '學生及監護人必須在註冊過程中提供準確、完整且最新的資訊。提供虛假資訊可能導致終止服務。' },
    
    sec3Title: { en: '3. Payment and Fees', zh: '3. 付款與費用' },
    sec3P1: { en: 'All class fees must be paid in advance. For bank or QR transfers, a valid receipt must be uploaded via the portal. Enrolment is only confirmed once payment is verified by the administration.', zh: '所有學費必須預先支付。對於銀行或二維碼轉帳，必須透過入口網站上傳有效的收據。報名僅在管理部門核實付款後才會確認。' },
    
    sec4Title: { en: '4. Class Attendance and Conduct', zh: '4. 上課出席與行為' },
    sec4P1: { en: 'Students are expected to arrive on time. ETS reserves the right to dismiss any student whose conduct is deemed detrimental to the learning environment or safety of others.', zh: '學生應準時到達。ETS 保留開除任何行為被認為對學習環境或他人安全有害的學生的權利。' },
    
    sec5Title: { en: '5. Liability and Waivers', zh: '5. 責任與豁免' },
    sec5P1: { en: 'While ETS takes all necessary precautions to ensure safety, participation in dance and physical activities involves inherent risks. ETS and its instructors are not liable for any injuries sustained during classes.', zh: '雖然 ETS 採取了所有必要的預防措施以確保安全，但參與舞蹈和體育活動具有固有的風險。ETS 及其導師對在課堂期間遭受的任何傷害不承擔任何責任。' },
    
    sec6Title: { en: '6. Changes to Terms', zh: '6. 條款變更' },
    sec6P1: { en: 'We reserve the right to modify or replace these terms at any time. Material changes will be communicated to registered users.', zh: '我們保留隨時修改或替換這些條款的權利。重大變更將通知註冊用戶。' }
  };

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', color: '#f5f5f5', padding: '40px 20px', fontFamily: "'Outfit', sans-serif" }}>
      <div style={{ maxWidth: 800, margin: '0 auto', backgroundColor: '#1a1a1a', padding: 40, borderRadius: 16, border: '1px solid rgba(255,255,255,0.1)' }}>
        <Link to="/" style={{ color: '#c04060', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600, marginBottom: 32 }}>
          {t(content.back, lang)}
        </Link>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: 32, fontWeight: 700, color: '#fff', fontFamily: "'Playfair Display', serif", margin: 0 }}>{t(content.title, lang)}</h1>
          
          <div style={{ display: 'flex', backgroundColor: '#333', borderRadius: 20, padding: 4 }}>
            <button 
              onClick={() => { setLang('en'); localStorage.setItem('ets_lang', 'en'); }}
              style={{ background: lang === 'en' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >EN</button>
            <button 
              onClick={() => { setLang('zh'); localStorage.setItem('ets_lang', 'zh'); }}
              style={{ background: lang === 'zh' ? '#c04060' : 'transparent', color: '#fff', border: 'none', borderRadius: 16, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
            >繁中</button>
          </div>
        </div>
        
        <div style={{ lineHeight: 1.6, fontSize: 15, color: 'rgba(255,255,255,0.8)' }}>
          <p style={{ marginBottom: 16 }}>{t(content.lastUpdated, lang)}{new Date().toLocaleDateString()}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec1Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec1P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec2Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec2P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec3Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec3P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec4Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec4P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec5Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec5P1, lang)}</p>
          
          <h2 style={{ fontSize: 20, color: '#fff', marginTop: 32, marginBottom: 16 }}>{t(content.sec6Title, lang)}</h2>
          <p style={{ marginBottom: 16 }}>{t(content.sec6P1, lang)}</p>
          <div style={{ marginTop: 32, padding: 16, backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: 8, lineHeight: 1.6 }}>
            <strong style={{ color: '#fff' }}>ETS (a.k.a Every Talent Shine Academy)</strong><br />
            UNIT20A, 5/F SING WIN FACTORY BUILDING<br />
            15-17 SHING YIP STREET KWUN TING,<br />
            KOWLOON HONG KONG<br />
            Represented By: Mrs. Esther Lam
          </div>
        </div>
      </div>
    </div>
  );
}
